<template>
    <v-data-table
        dense
        :headers="headers"
        :items="data"
        :loading="loading"
        :server-items-length="length"
        :options="options"
        @update:options="updateOptions"
        :footer-props="footer"
    >
        <template v-slot:[`item.code`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.po_good_receipt.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.code}}
        </template>

        <template v-slot:[`item.purchase_order_code`]="{item}">
            <span class="text-decoration-underline font-weight-bold" @click="showPurchaseOrder(item)" style="cursor: pointer">
                {{item.purchase_order_code}}
            </span>
        </template>

        <template v-slot:[`item.state`]="{item}">
            <PStatus :state="item.state"/>
        </template>

    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions';
import {mapActions, mapGetters} from 'vuex'
import PStatus from './../common/PStatus';

export default {
    name: "GoodReceiptList",
    components: {
        PStatus
    },
    data() {
        return {
            footer: {
                'items-per-page-options': [10, 25, 50]
            },
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Supplier", value: "supplier" },
                { text: "Order Code", value: "purchase_order_code" },
                { text: "State", value: "state" },
            ],
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            options: "purchase/goodReceipt/options",
            loading: "purchase/goodReceipt/loading",
            length: "purchase/goodReceipt/length",
            data: "purchase/goodReceipt/list",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "purchase/goodReceipt/updateOptions"
        }),
        handleClickRow(item) {
            this.$router.push({name: "GoodReceiptDisplay", params: {id: item.id}})
        },
        showPurchaseOrder(item) {
            this.$router.push({ name: "PurchaseOrderDisplay", params: { id: item.purchase_order_id } });
        }
    }
}
</script>

<style>

</style>